import React, { Component } from "react";
import ReactDOM from "react-dom";

/**
 * Renders a dropdown menu in a body portal, positioned from an anchor element's
 * bounding rect with edge-flipping. This escapes the sub-grid's `overflow`
 * clipping (and any sticky/z-index stacking) so menus never get cut off.
 *
 * Props: anchorRef (ref to the trigger), width, onClose, children.
 */
class PortalMenu extends Component {
	state = { style: null };

	componentDidMount() {
		const el = this.props.anchorRef && this.props.anchorRef.current;
		const rect = el
			? el.getBoundingClientRect()
			: { left: 0, right: 0, top: 0, bottom: 0, width: 180 };
		const vw = window.innerWidth;
		const vh = window.innerHeight;
		const menuW = this.props.width || Math.max(rect.width, 200);
		const menuMaxH = 260;
		const gap = 4;

		// Horizontal: prefer left-aligned with the trigger; clamp/flip to keep on-screen.
		let left = rect.left;
		if (left + menuW > vw - 8) left = Math.max(8, vw - menuW - 8);

		// Vertical: open downward unless there isn't room and there's more room above.
		const below = vh - rect.bottom;
		const openUp = below < menuMaxH + 8 && rect.top > below;
		const style = {
			position: "fixed",
			left,
			width: menuW,
			maxHeight: menuMaxH,
			zIndex: 9999,
		};
		if (openUp) style.bottom = vh - rect.top + gap;
		else style.top = rect.bottom + gap;

		this.setState({ style });
	}

	render() {
		return ReactDOM.createPortal(
			<>
				<div className="et-portal-backdrop" onClick={this.props.onClose} />
				<div
					className="et-cell__menu et-cell__menu--portal"
					style={this.state.style || { position: "fixed", visibility: "hidden" }}
				>
					{this.props.children}
				</div>
			</>,
			document.body,
		);
	}
}

export default PortalMenu;
